export default window.location.hostname.split('.')[0] === process.env.REACT_APP_SUBDOMAIN
